import React, { createContext, useContext } from "react";
import type { CommentsApi } from "./types";

/**
 * React context that injects the API adapter into <CommentThread>.
 *
 * Each consuming app (frontend, tenant-frontend) configures its own
 * adapter — this package never imports an OpenAPI client directly,
 * so it stays decoupled from the per-app generated client bundles.
 */

const CommentsContext = createContext<CommentsApi | null>(null);

export interface CommentsProviderProps {
  api: CommentsApi;
  children: React.ReactNode;
}

export const CommentsProvider: React.FC<CommentsProviderProps> = ({ api, children }) => (
  <CommentsContext.Provider value={api}>{children}</CommentsContext.Provider>
);

export function useCommentsApi(): CommentsApi {
  const ctx = useContext(CommentsContext);
  if (!ctx) {
    throw new Error(
      "useCommentsApi: missing <CommentsProvider> ancestor. Wrap your app once near the root.",
    );
  }
  return ctx;
}
